import { call, put } from 'redux-saga/effects';
import { get } from 'ravenjs/utils/lodash';

import { inProductMarketingSendEmailAPI, fetchUpsellAdsAPI } from 'modules/apis';
import * as inProductMarketingActions from '../actions';

/**
 * Function for send email
 *
 * @method sendEmailSaga
 * @type   {Generator}
 * @param  {Object} action The redux action
 * @return {Object} location
 */
export function* sendEmailSaga(action) {
    try {
        const {
            payload: { params },
        } = action;
        const response = yield call(inProductMarketingSendEmailAPI, params);
        const results = get(response, 'data.results', {});
        yield put(inProductMarketingActions.sendEmail.success(results));
        return results;
    } catch (error) {
        yield put(inProductMarketingActions.sendEmail.error(error));
        return error;
    }
}

/**
 * Saga to fetch upsell ads
 *
 * @method fetchUpsellAdsSaga
 * @type   {Generator}
 * @param  {Object} action The redux action
 * @return {Object}
 */
export function* fetchUpsellAdsSaga(action) {
    try {
        const { payload } = action;
        const response = yield call(fetchUpsellAdsAPI, payload);
        const data = get(response, 'data.results', {});
        yield put(inProductMarketingActions.fetchUpsellAds.success(data));
        return data;
    } catch (error) {
        yield put(inProductMarketingActions.fetchUpsellAds.error(error));
        return error;
    }
}
